// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file events_types.proto (package nail2poll, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Metadata, SORT_ORDER } from "./base_pb.js";

/**
 *
 * Describes the available sort keys for retrieving events types
 *
 * @generated from enum nail2poll.EVENT_TYPE_SORT_KEY
 */
export enum EVENT_TYPE_SORT_KEY {
  /**
   * Fetch ordered results by id
   *
   * @generated from enum value: EVENT_TYPE_SORT_KEY_ID_UNSPECIFIED = 0;
   */
  EVENT_TYPE_SORT_KEY_ID_UNSPECIFIED = 0,

  /**
   * Fetch ordered results by the creation timestamp
   *
   * @generated from enum value: EVENT_TYPE_SORT_KEY_CREATED_AT = 1;
   */
  EVENT_TYPE_SORT_KEY_CREATED_AT = 1,

  /**
   * Fetch ordered results by the modified timestamp
   *
   * @generated from enum value: EVENT_TYPE_SORT_KEY_MODIFIED_AT = 2;
   */
  EVENT_TYPE_SORT_KEY_MODIFIED_AT = 2,

  /**
   * Fetch ordered results by name
   *
   * @generated from enum value: EVENT_TYPE_SORT_KEY_NAME = 10;
   */
  EVENT_TYPE_SORT_KEY_NAME = 10,

  /**
   * Fetch ordered results by code
   *
   * @generated from enum value: EVENT_TYPE_SORT_KEY_CODE = 11;
   */
  EVENT_TYPE_SORT_KEY_CODE = 11,
}
// Retrieve enum metadata with: proto3.getEnumType(EVENT_TYPE_SORT_KEY)
proto3.util.setEnumType(EVENT_TYPE_SORT_KEY, "nail2poll.EVENT_TYPE_SORT_KEY", [
  { no: 0, name: "EVENT_TYPE_SORT_KEY_ID_UNSPECIFIED" },
  { no: 1, name: "EVENT_TYPE_SORT_KEY_CREATED_AT" },
  { no: 2, name: "EVENT_TYPE_SORT_KEY_MODIFIED_AT" },
  { no: 10, name: "EVENT_TYPE_SORT_KEY_NAME" },
  { no: 11, name: "EVENT_TYPE_SORT_KEY_CODE" },
]);

/**
 *
 * Describes the data structure of each event type on the platform
 *
 * @generated from message nail2poll.EventType
 */
export class EventType extends Message<EventType> {
  /**
   * Stores the metadata of this resource
   *
   * @generated from field: nail2poll.Metadata metadata = 1;
   */
  metadata?: Metadata;

  /**
   * The name of the event type
   *
   * @generated from field: string name = 10;
   */
  name = "";

  /**
   * Code of the event type
   *
   * @generated from field: string code = 11;
   */
  code = "";

  constructor(data?: PartialMessage<EventType>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "nail2poll.EventType";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "metadata", kind: "message", T: Metadata },
    { no: 10, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventType {
    return new EventType().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventType {
    return new EventType().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventType {
    return new EventType().fromJsonString(jsonString, options);
  }

  static equals(a: EventType | PlainMessage<EventType> | undefined, b: EventType | PlainMessage<EventType> | undefined): boolean {
    return proto3.util.equals(EventType, a, b);
  }
}

/**
 *
 * Describes the data structure that stores a list of events types
 *
 * @generated from message nail2poll.EventsTypesList
 */
export class EventsTypesList extends Message<EventsTypesList> {
  /**
   * List of events types
   *
   * @generated from field: repeated nail2poll.EventType list = 1;
   */
  list: EventType[] = [];

  constructor(data?: PartialMessage<EventsTypesList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "nail2poll.EventsTypesList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list", kind: "message", T: EventType, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventsTypesList {
    return new EventsTypesList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventsTypesList {
    return new EventsTypesList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventsTypesList {
    return new EventsTypesList().fromJsonString(jsonString, options);
  }

  static equals(a: EventsTypesList | PlainMessage<EventsTypesList> | undefined, b: EventsTypesList | PlainMessage<EventsTypesList> | undefined): boolean {
    return proto3.util.equals(EventsTypesList, a, b);
  }
}

/**
 *
 * Describes the data structure that responds to a pagination request
 *
 * @generated from message nail2poll.EventTypePaginationResp
 */
export class EventTypePaginationResp extends Message<EventTypePaginationResp> {
  /**
   * The number of records in this payload
   *
   * @generated from field: int64 count = 1;
   */
  count = protoInt64.zero;

  /**
   * The total number of records that are available
   *
   * @generated from field: int64 total = 2;
   */
  total = protoInt64.zero;

  /**
   * The list of records
   *
   * @generated from field: repeated nail2poll.EventType payload = 3;
   */
  payload: EventType[] = [];

  constructor(data?: PartialMessage<EventTypePaginationResp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "nail2poll.EventTypePaginationResp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "payload", kind: "message", T: EventType, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventTypePaginationResp {
    return new EventTypePaginationResp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventTypePaginationResp {
    return new EventTypePaginationResp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventTypePaginationResp {
    return new EventTypePaginationResp().fromJsonString(jsonString, options);
  }

  static equals(a: EventTypePaginationResp | PlainMessage<EventTypePaginationResp> | undefined, b: EventTypePaginationResp | PlainMessage<EventTypePaginationResp> | undefined): boolean {
    return proto3.util.equals(EventTypePaginationResp, a, b);
  }
}

/**
 *
 * Describes the necessary data structure during creation of a event type
 *
 * @generated from message nail2poll.EventsTypesServiceCreateRequest
 */
export class EventsTypesServiceCreateRequest extends Message<EventsTypesServiceCreateRequest> {
  /**
   * Stores any comment that the user might add during this operation
   *
   * @generated from field: string user_comment = 1;
   */
  userComment = "";

  /**
   * The name of the event type
   *
   * @generated from field: string name = 10;
   */
  name = "";

  /**
   * Code of the event type
   *
   * @generated from field: string code = 11;
   */
  code = "";

  constructor(data?: PartialMessage<EventsTypesServiceCreateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "nail2poll.EventsTypesServiceCreateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventsTypesServiceCreateRequest {
    return new EventsTypesServiceCreateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventsTypesServiceCreateRequest {
    return new EventsTypesServiceCreateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventsTypesServiceCreateRequest {
    return new EventsTypesServiceCreateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EventsTypesServiceCreateRequest | PlainMessage<EventsTypesServiceCreateRequest> | undefined, b: EventsTypesServiceCreateRequest | PlainMessage<EventsTypesServiceCreateRequest> | undefined): boolean {
    return proto3.util.equals(EventsTypesServiceCreateRequest, a, b);
  }
}

/**
 *
 * Describes the data structure to perform the update (draft/revision) operation on a event type
 *
 * @generated from message nail2poll.EventsTypesServiceUpdateRequest
 */
export class EventsTypesServiceUpdateRequest extends Message<EventsTypesServiceUpdateRequest> {
  /**
   * Stores any comment that the user might add during this operation
   *
   * @generated from field: string user_comment = 1;
   */
  userComment = "";

  /**
   * The UUID of the resource that needs to be updated
   *
   * @generated from field: string uuid = 2;
   */
  uuid = "";

  /**
   * The name of the event type
   *
   * @generated from field: string name = 10;
   */
  name = "";

  /**
   * Code of the event type
   *
   * @generated from field: string code = 11;
   */
  code = "";

  constructor(data?: PartialMessage<EventsTypesServiceUpdateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "nail2poll.EventsTypesServiceUpdateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventsTypesServiceUpdateRequest {
    return new EventsTypesServiceUpdateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventsTypesServiceUpdateRequest {
    return new EventsTypesServiceUpdateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventsTypesServiceUpdateRequest {
    return new EventsTypesServiceUpdateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EventsTypesServiceUpdateRequest | PlainMessage<EventsTypesServiceUpdateRequest> | undefined, b: EventsTypesServiceUpdateRequest | PlainMessage<EventsTypesServiceUpdateRequest> | undefined): boolean {
    return proto3.util.equals(EventsTypesServiceUpdateRequest, a, b);
  }
}

/**
 *
 * Describes a pagination request to retrieve records
 *
 * @generated from message nail2poll.EventsTypesServicePaginationReq
 */
export class EventsTypesServicePaginationReq extends Message<EventsTypesServicePaginationReq> {
  /**
   * If true, then returns only active records. If false, then returns only inactive records
   *
   * @generated from field: bool is_active = 1;
   */
  isActive = false;

  /**
   * The number of records that need to be sent in the response
   *
   * @generated from field: int64 count = 2;
   */
  count = protoInt64.zero;

  /**
   * The number that need to be offset by before fetching the records
   *
   * @generated from field: int64 offset = 3;
   */
  offset = protoInt64.zero;

  /**
   * The sort order that is to be used to fetch the pagination response
   *
   * @generated from field: nail2poll.SORT_ORDER sort_order = 4;
   */
  sortOrder = SORT_ORDER.ASCENDING_UNSPECIFIED;

  /**
   * The sort key that is to be used to fetch the pagination response
   *
   * @generated from field: nail2poll.EVENT_TYPE_SORT_KEY sort_key = 5;
   */
  sortKey = EVENT_TYPE_SORT_KEY.EVENT_TYPE_SORT_KEY_ID_UNSPECIFIED;

  constructor(data?: PartialMessage<EventsTypesServicePaginationReq>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "nail2poll.EventsTypesServicePaginationReq";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "offset", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "sort_order", kind: "enum", T: proto3.getEnumType(SORT_ORDER) },
    { no: 5, name: "sort_key", kind: "enum", T: proto3.getEnumType(EVENT_TYPE_SORT_KEY) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventsTypesServicePaginationReq {
    return new EventsTypesServicePaginationReq().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventsTypesServicePaginationReq {
    return new EventsTypesServicePaginationReq().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventsTypesServicePaginationReq {
    return new EventsTypesServicePaginationReq().fromJsonString(jsonString, options);
  }

  static equals(a: EventsTypesServicePaginationReq | PlainMessage<EventsTypesServicePaginationReq> | undefined, b: EventsTypesServicePaginationReq | PlainMessage<EventsTypesServicePaginationReq> | undefined): boolean {
    return proto3.util.equals(EventsTypesServicePaginationReq, a, b);
  }
}

/**
 *
 * Describes the base request payload of a filter search
 *
 * @generated from message nail2poll.EventsTypesServiceFilterReq
 */
export class EventsTypesServiceFilterReq extends Message<EventsTypesServiceFilterReq> {
  /**
   * If true, then returns only active records. If false, then returns only inactive records
   *
   * @generated from field: bool is_active = 1;
   */
  isActive = false;

  /**
   * The number of records that need to be sent in the response. Returns all records if it is set to -1
   *
   * @generated from field: int64 count = 2;
   */
  count = protoInt64.zero;

  /**
   * The number that need to be offset by before fetching the records
   *
   * @generated from field: int64 offset = 3;
   */
  offset = protoInt64.zero;

  /**
   * The sort order that is to be used to fetch the pagination response
   *
   * @generated from field: nail2poll.SORT_ORDER sort_order = 4;
   */
  sortOrder = SORT_ORDER.ASCENDING_UNSPECIFIED;

  /**
   * The sort key that is to be used to fetch the pagination response
   *
   * @generated from field: nail2poll.EVENT_TYPE_SORT_KEY sort_key = 5;
   */
  sortKey = EVENT_TYPE_SORT_KEY.EVENT_TYPE_SORT_KEY_ID_UNSPECIFIED;

  /**
   * The minimum timestamp that needs to be considered to filter by creation
   *
   * @generated from field: int64 creation_timestamp_start = 6;
   */
  creationTimestampStart = protoInt64.zero;

  /**
   * The maximum timestamp that needs to be considered to filter by creation
   *
   * @generated from field: int64 creation_timestamp_end = 7;
   */
  creationTimestampEnd = protoInt64.zero;

  /**
   * The name of the event type
   *
   * @generated from field: string name = 20;
   */
  name = "";

  /**
   * Code of the event type
   *
   * @generated from field: string code = 21;
   */
  code = "";

  constructor(data?: PartialMessage<EventsTypesServiceFilterReq>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "nail2poll.EventsTypesServiceFilterReq";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "offset", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "sort_order", kind: "enum", T: proto3.getEnumType(SORT_ORDER) },
    { no: 5, name: "sort_key", kind: "enum", T: proto3.getEnumType(EVENT_TYPE_SORT_KEY) },
    { no: 6, name: "creation_timestamp_start", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "creation_timestamp_end", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 20, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventsTypesServiceFilterReq {
    return new EventsTypesServiceFilterReq().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventsTypesServiceFilterReq {
    return new EventsTypesServiceFilterReq().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventsTypesServiceFilterReq {
    return new EventsTypesServiceFilterReq().fromJsonString(jsonString, options);
  }

  static equals(a: EventsTypesServiceFilterReq | PlainMessage<EventsTypesServiceFilterReq> | undefined, b: EventsTypesServiceFilterReq | PlainMessage<EventsTypesServiceFilterReq> | undefined): boolean {
    return proto3.util.equals(EventsTypesServiceFilterReq, a, b);
  }
}

/**
 *
 * Describes the request payload for performing a generic search operation on records
 *
 * @generated from message nail2poll.EventsTypesServiceSearchAllReq
 */
export class EventsTypesServiceSearchAllReq extends Message<EventsTypesServiceSearchAllReq> {
  /**
   * If true, then returns only active records. If false, then returns only inactive records
   *
   * @generated from field: bool is_active = 1;
   */
  isActive = false;

  /**
   * The number of records that need to be sent in the response. Returns all records if it is set to -1
   *
   * @generated from field: int64 count = 2;
   */
  count = protoInt64.zero;

  /**
   * The number that need to be offset by before fetching the records
   *
   * @generated from field: int64 offset = 3;
   */
  offset = protoInt64.zero;

  /**
   * The sort order that is to be used to fetch the pagination response
   *
   * @generated from field: nail2poll.SORT_ORDER sort_order = 4;
   */
  sortOrder = SORT_ORDER.ASCENDING_UNSPECIFIED;

  /**
   * The sort key that is to be used to fetch the pagination response
   *
   * @generated from field: nail2poll.EVENT_TYPE_SORT_KEY sort_key = 5;
   */
  sortKey = EVENT_TYPE_SORT_KEY.EVENT_TYPE_SORT_KEY_ID_UNSPECIFIED;

  /**
   * Describes the key with which the search operation needs to be performed
   *
   * @generated from field: string search_key = 20;
   */
  searchKey = "";

  constructor(data?: PartialMessage<EventsTypesServiceSearchAllReq>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "nail2poll.EventsTypesServiceSearchAllReq";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "offset", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "sort_order", kind: "enum", T: proto3.getEnumType(SORT_ORDER) },
    { no: 5, name: "sort_key", kind: "enum", T: proto3.getEnumType(EVENT_TYPE_SORT_KEY) },
    { no: 20, name: "search_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventsTypesServiceSearchAllReq {
    return new EventsTypesServiceSearchAllReq().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventsTypesServiceSearchAllReq {
    return new EventsTypesServiceSearchAllReq().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventsTypesServiceSearchAllReq {
    return new EventsTypesServiceSearchAllReq().fromJsonString(jsonString, options);
  }

  static equals(a: EventsTypesServiceSearchAllReq | PlainMessage<EventsTypesServiceSearchAllReq> | undefined, b: EventsTypesServiceSearchAllReq | PlainMessage<EventsTypesServiceSearchAllReq> | undefined): boolean {
    return proto3.util.equals(EventsTypesServiceSearchAllReq, a, b);
  }
}

